import { colors } from '../styles/colors';

type ActivityIconProps = {
  color?: string;
  size?: string;
}

export const ActivityIcon = ({ size = '24', color = colors.White }: ActivityIconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 12H18L15 21L9 3L6 12H2" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
